import React, { useState, useEffect } from 'react';

import { Link } from "react-router-dom"
import EventOrderList from "./EventOrderList"
import { FaCreditCard, FaChevronRight } from "react-icons/fa"

const EventOrderPayments = () => {
  const [step, setStep] = useState("options")
  const [selectedOption, setSelectedOption] = useState("create")
  const [paymentDate, setPaymentDate] = useState(new Date())
  const [paymentTime, setPaymentTime] = useState(new Date())
  const [selectedTickets, setSelectedTickets] = useState({})
  const [guestCounts, setGuestCounts] = useState({})
  const [attendees, setAttendees] = useState([])
  const [activeAttendee, setActiveAttendee] = useState(0)
  const [addOns, setAddOns] = useState({})
  const [showImportModal, setShowImportModal] = useState(false)
  const [isSearchbar, toggleSearchBar] = useState(false)
  const [selection, setSelection] = useState("attendees")

  const [quantities, setQuantities] = useState({
    addon1: 0,
    addon2: 0,
  })
  const [selection1, setSelection1] = useState("attendees1")

  const handleIncrease = (id) => {
    setQuantities((prev) => ({ ...prev, [id]: prev[id] + 1 }))
  }

  const handleDecrease = (id) => {
    setQuantities((prev) => ({ ...prev, [id]: Math.max(0, prev[id] - 1) }))
  }

  const [paymentMethod, setPaymentMethod] = useState("Other")
  const [amount, setAmount] = useState("")
  const [transactionId, setTransactionId] = useState("")
  const [notes, setNotes] = useState("")

  const methods = ["Bank Transfer", "Cheque", "Cash", "Other"]
  const [activeStep, setActiveStep] = useState(1)

  const nextStep = () => {
    if (activeStep < 6) setActiveStep(activeStep + 1)
  }

  const prevStep = () => {
    if (activeStep > 1) setActiveStep(activeStep - 1)
  }

  const [selected, setSelected] = useState("Company / Institution")
  const options = [
    { id: "person", label: "Person", icon: <i className="fa fa-desktop"></i> },
    { id: "Company / Institution", label: "Company / Institution", icon: <i className="fa fa-building-o"></i> },
  ]

  const [selectedOrderType, setSelectedOrderType] = useState("All")
  const handleOrderTypeChange = (eventKey) => {
    setSelectedOrderType(eventKey)
  }

  useEffect(() => {
    const totalAttendees = Object.values(selectedTickets).reduce((sum, quantity) => sum + quantity, 0)

    if (totalAttendees > attendees.length) {
      const newAttendees = [...attendees]
      for (let i = attendees.length; i < totalAttendees; i++) {
        newAttendees.push({
          email: "",
          salutation: "",
          firstName: "",
          middleName: "",
          lastName: "",
          state: "",
          ticket: Object.keys(selectedTickets)[0] || "",
          addOns: [],
        })
      }
      setAttendees(newAttendees)
    } else if (totalAttendees < attendees.length) {
      setAttendees(attendees.slice(0, totalAttendees))
    }
  }, [selectedTickets])

  const handleAddTicket = (ticketId) => {
    setSelectedTickets({
      ...selectedTickets,
      [ticketId]: selectedTickets[ticketId] ? selectedTickets[ticketId] + 1 : 1,
    })
  }

  const handleIncreaseQuantity = (ticketId) => {
    setSelectedTickets({
      ...selectedTickets,
      [ticketId]: selectedTickets[ticketId] ? selectedTickets[ticketId] + 1 : 1,
    })
  }

  const handleDecreaseQuantity = (ticketId) => {
    if (selectedTickets[ticketId] && selectedTickets[ticketId] > 0) {
      const newQuantity = selectedTickets[ticketId] - 1

      if (newQuantity === 0) {
        const newSelectedTickets = { ...selectedTickets }
        delete newSelectedTickets[ticketId]
        setSelectedTickets(newSelectedTickets)
      } else {
        setSelectedTickets({
          ...selectedTickets,
          [ticketId]: newQuantity,
        })
      }
    }
  }

  const handleImportComplete = (importedData) => {
    const newAttendees = importedData.map((row) => ({
      email: row[1] || "",
      firstName: row[0]?.split(" ")[0] || "",
      lastName: row[0]?.split(" ").slice(1).join(" ") || "",
      salutation: "",
      middleName: "",
      state: "",
      ticket: Object.keys(selectedTickets)[0] || ticketOptions[0].id,
      addOns: [],
    }))

    setAttendees(newAttendees)
    setStep("attendees")
    setShowImportModal(false)
  }

  const ticketOptions = [
    {
      id: "fmas",
      name: "AMASICON 2025 - Delegate",
      price: 12980,
      currency: "INR",
      description: "For IHBA / HSI members",
    },
    {
      id: "gynaecologist",
      name: "Scientific Paper Writing Certificate Course",
      price: 7670,
      currency: "INR",
      description:
        "To be held on 28th August, 2025 and doesn't include conference fee. This is for all other specialities excluding Surgeons & Gynaecologists",
    },
    {
      id: "non-amasi",
      name: "FMAS Convocation Delegates (Surgery)",
      price: 14160,
      currency: "INR",
      description: "2 days registration only",
    },
    {
      id: "amasi-member",
      name: "Gynaecologist (Two Days registration only - 28th and 29th August)",
      price: 10500,
      currency: "INR",
      description: "2 days registration only",
    },
    {
      id: "pgs-nbe",
      name: "Non AMASI Member",
      price: 8500,
      currency: "INR",
      description: "2 days registration only",
    },
    {
      id: "delegates",
      name: "Delegates (Sri Lanka, Nepal, Bhutan, Mauritius & Bangladesh)",
      price: 170,
      currency: "USD",
      description: "2 days registration only",
    },
  ]

  const handleAddGuests = (ticketId) => {
    setGuestCounts({
      ...guestCounts,
      [ticketId]: guestCounts[ticketId] ? guestCounts[ticketId] + 1 : 1,
    })
  }

  return (
    <>
      <div className={`overlay ${isSearchbar ? "active" : ""}`} onClick={() => toggleSearchBar(false)}></div>

      {/* Enhanced Header Section */}
      <div style={{ backgroundColor: "#f9fafb", minHeight: "100vh" }}>
        <div style={{ padding: "24px 15px" }}>
          {/* Modern Header Card */}
          <div style={{ marginBottom: "22px" }}>
            <div className="brood_comes_div">
              <div className="row align-items-center">
                <div className="col-md-6 brood_comes_heading">
                  <h2  >
                    <div className="brood_comes_part">
                      <FaCreditCard />
                    </div>
                    Orders & Payments
                  </h2>
                  {/* Enhanced Breadcrumb */}
                  {/* <nav aria-label="breadcrumb">
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Link
                        to="/events/admin/"
                        style={{
                          color: "#6b7280",
                          textDecoration: "none",
                          fontSize: "14px",
                          transition: "color 0.2s ease",
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "#184778")}
                        onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                      >
                        AMASI
                      </Link>
                      <FaChevronRight size={10} style={{ color: "#d1d5db" }} />
                      <span style={{ color: "#184778", fontSize: "14px", fontWeight: "500" }}>Orders & Payments</span>
                    </div>
                  </nav> */}
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div>
            <EventOrderList />
          </div>
        </div>
      </div>
    </>
  )
}

export default EventOrderPayments
